module.exports = __webpack_public_path__ + "static/media/cz_karta klienta_profi_tekst9.15595d4a.webp";